import React from 'react';

import PropTypes from 'prop-types';

import {
    Typography,
    Section,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import AmenitiesCard from '../AmenitiesCard/AmenitiesCard';

import styles from './AmenitiesSection.scss';

const propTypes = {
    amenitiesContent: PropTypes.arrayOf(PropTypes.shape({
        description: PropTypes.string,
        title: PropTypes.string,
    })),
    namespace: PropTypes.string,
    sectionTitle: PropTypes.string,
};

const defaultProps = {
    amenitiesContent: [],
    namespace: '',
    sectionTitle: '',
};

const AmenitiesSection = (props) => {
    const {
        t,
        namespace,
        sectionTitle,
        amenitiesContent = [],
    } = props;
    return (
        <>
            <Section>
                <Typography
                    component="h2"
                    id="amenities-header-section"
                    variant="h3"
                >
                    {sectionTitle}
                </Typography>
                <div className={styles.amenitiesBox}>
                    {amenitiesContent.map(({ title, description }) => (
                        <AmenitiesCard
                            description={t(`${namespace}:${description}`)}
                            key={title}
                            title={t(`${namespace}:${title}`)}
                        />
                    ))}
                </div>
            </Section>
        </>
    );
};

AmenitiesSection.propTypes = propTypes;
AmenitiesSection.defaultProps = defaultProps;

export { AmenitiesSection };
export default localize(AmenitiesSection);
